/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ViewViolationResponse {
    getFixupPrototypeFunction() { return ViewViolationResponse.fixupPrototype; }

    static newInstance(model: Partial<ViewViolationResponse>): ViewViolationResponse {
        let obj = Object.assign(new ViewViolationResponse(), model);
        ViewViolationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ViewViolationResponse>): ViewViolationResponse {
        if (!model) return null;
        return ViewViolationResponse.newInstance(<ViewViolationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ViewViolationResponse) {
        if (!obj) return;

        models.ViewViolationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ViewViolationResponse): boolean {
        Object.setPrototypeOf(obj, ViewViolationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.details) {
            for (let val of this.details) {
                models.ViewViolationModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Total violations count
     */
    total_count: number;

    /**
     * Count of number of pages
     */
    page_count: string;

    /**
     * Details of violation
     */
    details: Array<models.ViewViolationModel>;

}
